import React from 'react'
import GreenUpArrow from "../../assets/up-arrow-green.svg"
import { useNavigate } from 'react-router-dom'

type Props = {
    menu: NavbarMenu,
    isSelected: boolean,
    isOpen: boolean,
    handleOpen: (openedTitle: string) => void
}

const Menu = ({ menu, isSelected, isOpen, handleOpen }: Props) => {
    const navigate = useNavigate()
    const handleRedirect = (path: string, isDisabled?: boolean) => {
        if (isDisabled) {
            return
        }
        else {
            navigate(path)
            handleOpen("")
        }
    }
    return (
        <div className={`flex justify-start items-center gap-1 px-[1vw] py-[1.6vh] relative ${isSelected || isOpen
            ? "border-b-[3px] border-deloitteGreen font-semibold text-deloitteGreen"
            : ""
            } `}>
            <div className='flex justify-between w-full'>
                <p className={`navbar-menu font-semibold mx-[0.7vw] text-black  `}>{menu.title}</p>
                <img className={`w-[0.7vw] ${isOpen ? "" : "rotate-180"}`} src={GreenUpArrow} alt="Dropdown" />
            </div>
            <div className='z-[9999] hidden'></div>
            {isOpen &&
                <div className="absolute top-[100%] left-0 w-full translate-y-[3px] m-auto z-[10000]">
                    <ul >
                        {menu.subMenus.map((subMenu) => (
                            <li key={subMenu.name} className={`flex items-center p-[7px] border-[1px] bg-white justify-between ${subMenu.disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => handleRedirect(subMenu.route, subMenu.disabled)} >
                                <span className="navbar-submenu font-semibold text-[#000]">{subMenu.name}</span>
                                <img className="w-[0.5vw] rotate-90" src={GreenUpArrow} alt="rightarrow" />
                            </li>
                        ))}
                    </ul>
                </div>}
        </div>
    )
}

export default Menu